import { render, staticRenderFns } from "./PrimaryFacetFilter.vue?vue&type=template&id=254bab46&"
import script from "./PrimaryFacetFilter.vue?vue&type=script&lang=js&"
export * from "./PrimaryFacetFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports